<script lang="ts">
    import L from "leaflet";
    import Draw from "leaflet-draw";
    import MarkerClusterGroup from "leaflet.markercluster";
    import { onMount } from "svelte";
    import type { PlayerListEntry } from "../../../../../../admin-service-typescript-client";
    import { ApiClient } from "../../../../../GlobalHelper/ApiClient";
    import { user } from "../../../../../store/stores";

    export let selectedPlayers: PlayerListEntry[];
    export let onSelect: (players: PlayerListEntry[]) => void;
    export let onDeselect: (players: PlayerListEntry[]) => void;

    let geoData;
    let map;
    let mapArea;
    let data;

    function isMarkerInsidePolygon(marker, poly) {
        var polyPoints = poly.getLatLngs()[0];
        var x = marker.getLatLng().lat,
            y = marker.getLatLng().lng;
        var inside = false;
        for (
            var i = 0, j = polyPoints.length - 1;
            i < polyPoints.length;
            j = i++
        ) {
            var xi = polyPoints[i].lat,
                yi = polyPoints[i].lng;
            var xj = polyPoints[j].lat,
                yj = polyPoints[j].lng;
            var intersect =
                yi > y != yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
            if (intersect) inside = !inside;
        }

        return inside;
    }

    function isMarkerInsideCircle(marker, poly) {
        var polyPoints = poly.getLatLngs()[0];
        var x = marker.getLatLng().lat,
            y = marker.getLatLng().lng;
        var inside = false;
        for (
            var i = 0, j = polyPoints.length - 1;
            i < polyPoints.length;
            j = i++
        ) {
            var xi = polyPoints[i].lat,
                yi = polyPoints[i].lng;
            var xj = polyPoints[j].lat,
                yj = polyPoints[j].lng;
            var intersect =
                yi > y != yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
            if (intersect) inside = !inside;
        }

        return inside;
    }

    const addMarker = (marker, poly, markerData) => {
        if (isMarkerInsidePolygon(marker, poly))
            onSelect([
                {
                    ...markerData,
                },
            ]);
    };

    const removeMarker = (marker, poly, markerData) => {
        if (isMarkerInsidePolygon(marker, poly))
            onDeselect([
                {
                    ...markerData,
                },
            ]);
    };

    const getStations = async () => {
        await $user.updateToken().then(async () => {
            await ApiClient.getInstance($user)
                .locationClient.listGeoLocationsOfAllLocations({})
                .then((locations) => {
                    const markers = L.markerClusterGroup();
                    geoData = locations;
                    locations
                        // .filter((location) => location.networkId === network.id)
                        .forEach((geoData) => {
                            if (
                                geoData.geoLocation?.latitude &&
                                geoData.geoLocation?.longitude
                            ) {
                                const marker = L.marker([
                                    geoData.geoLocation.latitude,
                                    geoData.geoLocation.longitude,
                                ]);
                                markers.addLayer(marker);
                                map.on("draw:created", function (e) {
                                    var type = e.layerType,
                                        layer = e.layer;
                                    addMarker(marker, layer, geoData);
                                });
                                map.on("draw:deleted", function (e) {
                                    var type = e.layerType,
                                        layer = e.layer;
                                    removeMarker(marker, layer, geoData);
                                });
                            }
                        });
                    map.addLayer(markers);
                    markers.bringToBack();
                    var editableLayers = new L.FeatureGroup();
                    map.addLayer(editableLayers);

                    var options = {
                        position: "topleft",
                        draw: {
                            polygon: {
                                allowIntersection: false, // Restricts shapes to simple polygons
                                drawError: {
                                    color: "#e1e100", // Color the shape will turn when intersects
                                    message:
                                        "<strong>Oh snap!<strong> you can't draw that!", // Message that will show when intersect
                                },
                                shapeOptions: {
                                    color: "#97009c",
                                },
                            },
                            // polyline: {
                            //     shapeOptions: {
                            //         color: "#f357a1",
                            //         weight: 10,
                            //     },
                            // },
                            // disable toolbar item by setting it to false
                            polyline: false,
                            circle: true, // Turns off this drawing tool
                            // polygon: true,
                            marker: false,
                            rectangle: true,
                        },
                        edit: {
                            featureGroup: editableLayers, //REQUIRED!!
                            remove: true,
                        },
                    };

                    // Initialise the draw control and pass it the FeatureGroup of editable layers
                    var drawControl = new L.Control.Draw(options);
                    map.addControl(drawControl);

                    // var editableLayers = new L.FeatureGroup();
                    // map.addLayer(editableLayers);

                    map.on("draw:created", function (e) {
                        var type = e.layerType,
                            layer = e.layer;

                        if (type === "polyline") {
                            layer.bindPopup("A polyline!");
                        } else if (type === "polygon") {
                            layer.bindPopup("A polygon!");
                        } else if (type === "marker") {
                            layer.bindPopup("marker!");
                        } else if (type === "circle") {
                            layer.bindPopup("A circle!");
                        } else if (type === "rectangle") {
                            layer.bindPopup("A rectangle!");
                        }

                        editableLayers.addLayer(layer);
                    });
                });
        });
    };

    const initialView = [52.8283, 9.5795];
    function createMap(container) {
        map = L.map(container, { preferCanvas: true }).setView(initialView, 5);
        let k = L.tileLayer(
            "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png",
            {
                attribution: `&copy;<a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>,
	        &copy;<a href="https://carto.com/attributions" target="_blank">CARTO</a>`,
                subdomains: "abcd",
                maxZoom: 14,
            }
        );
        // L.getLayer.getPane().style.zIndex = 10;
        k.addTo(map);

        return map;
    }
    onMount(async () => {
        map.remove();
        mapAction(mapArea);
        await getStations();
    });
    function mapAction(container) {
        map = createMap(container);
        map;

        return {
            destroy: () => {
                map.remove();
                map = null;
            },
        };
    }
</script>

<link
    rel="stylesheet"
    href="https://unpkg.com/leaflet@1.6.0/dist/leaflet.css"
    integrity="sha512-xwE/Az9zrjBIphAcBb3F6JVqxf46+CDLwfLMHloNu6KEQCAWi6HcDUbeOfBIptF7tcCzusKFjFw2yuvEpDL9wQ=="
    crossorigin=""
/>
<div
    class="map"
    style="height:100%;width:100%"
    use:mapAction
    bind:this={mapArea}
/>

<style>
</style>
